import { Button, Radio, Select } from "antd";
import type { CatalogOrderOption } from "../Orders/catalogOrderService.ts";
import OrderAgencyField from "./OrderAgencyField.tsx";
import StoreTextField from "./StoreTextField.tsx";
import { t, useStoreLanguage, localizeDigits } from "../../../features/store-language/i18n.ts";
import PortalDialog from "../../shared/PortalDialog.tsx";
import { compactOrderNumber } from "../Orders/orderNumber.ts";
import "../../../features/platform-admin/platform-admin-tokens.css";
import "./StoreOrderDialog.css";

export default function StoreOrderDialog({ open, pending, retry, selectionOnly = false, latestLabel, drafts, selectedId, onSelect, mode, title, onMode, onTitle, onSubmit, onClose, salesAgencyId, onAgencyChange }: {
  salesAgencyId?: number;
  onAgencyChange: (value: number) => void;
  open: boolean;
  pending: boolean;
  retry: boolean;
  selectionOnly?: boolean;
  latestLabel?: string;
  drafts: CatalogOrderOption[];
  selectedId?: number;
  onSelect: (id: number) => void;
  mode: "latest" | "new";
  title: string;
  onMode: (mode: "latest" | "new") => void;
  onTitle: (title: string) => void;
  onSubmit: () => Promise<void>;
  onClose: () => void;
}) {
  useStoreLanguage();
  return (
    <PortalDialog
      open={open}
      title={t("انتخاب سفارش جاری")}
      className="store-order-dialog"
      onClose={onClose}
      busy={pending}
      footer={(
        <div className="store-order-dialog__actions">
          <Button
            type="primary"
            loading={pending}
            disabled={pending}
            onClick={onSubmit}
          >
            {retry ? t("تلاش مجدد") : selectionOnly ? t("تأیید") : t("افزودن به سفارش")}
          </Button>
          <Button
            disabled={pending}
            onClick={onClose}
          >
            {t("انصراف")}
          </Button>
        </div>
      )}
    >
      {retry ? (
        <p>{t("نتیجهٔ درخواست قبلی مشخص نیست؛ تلاش مجدد همان درخواست را بررسی می‌کند.")}</p>
      ) : (
        <>
          <p>{t("این انتخاب برای کالاهای بعدی هم استفاده می‌شود؛ هر زمان می‌توانید سفارش جاری را تغییر دهید.")}</p>
          <Radio.Group
            value={mode}
            disabled={pending}
            onChange={function (event) { onMode(event.target.value); }}
          >
            {latestLabel ? (
              <Radio value="latest">
                {t("سفارش پیش‌نویس موجود")}
              </Radio>
            ) : null}
            <Radio value="new">{t("سفارش جدید")}</Radio>
          </Radio.Group>
          {mode === "latest" ? (
            <div className="store-order-dialog__field">
              <Select
                aria-label={t("انتخاب سفارش جاری")}
                value={selectedId}
                disabled={pending}
                showSearch
                optionFilterProp="label"
                getPopupContainer={function (trigger) { return trigger.parentElement!; }}
                options={drafts.map(function (draft) {
                  const orderNumber = compactOrderNumber(draft.orderNumber);
                  return { value: draft.id, label: localizeDigits([draft.title || orderNumber, orderNumber, draft.agencyTitle].filter(Boolean).join(" · ")) };
                })}
                onChange={onSelect}
              />
            </div>
          ) : null}
          {mode === "new" ? (
            <div className="store-order-dialog__field">
              <OrderAgencyField
                value={salesAgencyId}
                onChange={onAgencyChange}
                disabled={pending}
              />
              <StoreTextField
                label={t("عنوان سفارش")}
                autoFocus
                required
                maxLength={200}
                disabled={pending}
                value={title}
                onChange={onTitle}
              />
            </div>
          ) : null}
        </>
      )}
    </PortalDialog>
  );
}
